var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMaximize = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5039 4166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-5039 -4166)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.765,27A1.809,1.809,0,0,1,7,25.235V8.765A1.809,1.809,0,0,1,8.765,7H25.235A1.809,1.809,0,0,1,27,8.765V25.235A1.809,1.809,0,0,1,25.235,27Zm0-1.765H25.235V8.765H8.765Zm0-16.471v0Z",
    transform: "translate(-5044 -4171)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaximize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/maximize.168faea7.svg";
export { ForwardRef as ReactComponent };